import { createTheme } from '@mui/material';

export const appTheme = createTheme({
  colors: {
    sideBarColor: '#1A1C20',
    color1: '#FFFFFF',
    color2: '#F5F5F5',
    secendaryColor: '#2D2F34',
    opositPrimary: '#3A3D42',
  },

  palette: {
    mode: 'light',

    primary: {
      main: '#3A3D42',
      light: '#4A4D52',
      dark: '#2A2C2F',
      contrastText: '#FFFFFF',
    },

    secondary: {
      main: '#2D2F34',
      light: '#3C3E42',
      dark: '#1F2023',
      contrastText: '#FFFFFF',
    },

    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
      lightBackground: '#DBDBDB',
      blueBackground: '#3b82f6',
    },

    text: {
      primary: '#3C3E42',
      secondary: '#C7C7C7',
    },
  },

  typography: {
    fontFamily: `'Inter', sans-serif`,
  },
});
